"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "allergy-list" };
var _hoisted_2 = { class: "allergy-list-header" };
var _hoisted_3 = { class: "header-title" };
var _hoisted_4 = { class: "allergy-summary" };
var _hoisted_5 = { class: "summary-badge active" };
var _hoisted_6 = { class: "count" };
var _hoisted_7 = {
    key: 0,
    class: "summary-badge critical"
};
var _hoisted_8 = {
    key: 0,
    class: "allergy-card nkda-card nkda-card--mobile-header"
};
var _hoisted_9 = { class: "header-actions" };
var _hoisted_10 = { class: "allergy-filters" };
var _hoisted_11 = { class: "filter-search" };
var _hoisted_12 = { class: "filter-group" };
var _hoisted_13 = {
    key: 0,
    class: "allergy-load-error",
    role: "alert"
};
var _hoisted_14 = {
    key: "nkda-card",
    class: "allergy-card nkda-card nkda-card--list"
};
var _hoisted_15 = { class: "card-header" };
var _hoisted_16 = { class: "allergy-name-row" };
var _hoisted_17 = { class: "allergy-name" };
var _hoisted_18 = { class: "card-actions" };
var _hoisted_19 = ["onClick"];
var _hoisted_20 = { class: "dropdown-container" };
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
    key: 0,
    class: "dropdown-menu"
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = ["onClick"];
var _hoisted_25 = ["onClick"];
var _hoisted_26 = { class: "card-body" };
var _hoisted_27 = { class: "info-row" };
var _hoisted_28 = { class: "info-item" };
var _hoisted_29 = { class: "info-item" };
var _hoisted_30 = { class: "info-item" };
var _hoisted_31 = {
    key: 0,
    class: "glyphicon glyphicon-warning-sign bi-exclamation-triangle"
};
var _hoisted_32 = {
    key: 0,
    class: "reactions-row"
};
var _hoisted_33 = { class: "reactions-list" };
var _hoisted_34 = {
    key: 0,
    class: "more-reactions"
};
var _hoisted_35 = {
    key: 1,
    class: "cross-reactivity-alert"
};
var _hoisted_36 = { class: "alert-items" };
var _hoisted_37 = { class: "card-footer" };
var _hoisted_38 = { class: "footer-info" };
var _hoisted_39 = {
    key: 0,
    class: "footer-info resolved"
};
var _hoisted_40 = { class: "footer-info" };
var _hoisted_41 = {
    key: 1,
    class: "empty-state"
};
var _hoisted_42 = { class: "view-modal" };
var _hoisted_43 = { class: "view-modal-header" };
var _hoisted_44 = { class: "modal-title-row" };
var _hoisted_45 = { class: "view-modal-body" };
var _hoisted_46 = { class: "detail-grid" };
var _hoisted_47 = { class: "detail-item" };
var _hoisted_48 = { class: "detail-item" };
var _hoisted_49 = { class: "detail-item" };
var _hoisted_50 = { class: "detail-item" };
var _hoisted_51 = { class: "detail-item" };
var _hoisted_52 = { class: "detail-item" };
var _hoisted_53 = {
    key: 0,
    class: "detail-section"
};
var _hoisted_54 = { class: "reactions-detail-list" };
var _hoisted_55 = { class: "reaction-name" };
var _hoisted_56 = {
    key: 1,
    class: "detail-section"
};
var _hoisted_57 = { class: "cross-items" };
var _hoisted_58 = {
    key: 2,
    class: "detail-section"
};
var _hoisted_59 = ["innerHTML"];
var _hoisted_60 = { class: "detail-section audit" };
var _hoisted_61 = { class: "audit-item" };
var _hoisted_62 = { class: "audit-item" };
var _hoisted_63 = { class: "view-modal-footer" };
var vue_3 = require("vue");
var allergyStore_1 = require("../../../stores/allergyStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AllergyList',
    emits: ["add", "edit"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        console.log("Allergy ListStores Informaiton");
        var stores = (0, allergyStore_1.useAllergyStore)();
        (0, vue_3.onMounted)(function () {
            console.log("Stores Informaiton");
            stores.getbackendAllergies();
            stores.allergies;
            try {
                console.log(stores.allergies);
            }
            catch (error) {
                console.error("Error fetching allergies:", error);
            }
            //stores.allergies;
        });
        var emit = __emit;
        //const stores = useAllergyStore()
        var openMenuId = (0, vue_3.ref)(null);
        var viewingAllergy = (0, vue_3.ref)(null);
        var activeCount = (0, vue_3.computed)(function () { return stores.activeAllergies.length || 0; });
        var highCriticalityCount = (0, vue_3.computed)(function () { return stores.highCriticalityCount; });
        // Synthetic, UI-only "No Known Drug Allergies" card — never written to the
        // backend as a real allergy row (that would pollute active-allergy counts,
        // med-interaction checks, etc.). Purely derived from the raw list length, so
        // it appears/disappears the instant an allergy is added or the last one is
        // removed — no page refresh, no manual add/remove bookkeeping.
        //
        // Only for a list that was READ and is empty (the store's noAllergiesOnRecord):
        // while the first read is in flight, with no chart open, and after a read that
        // failed, the list is empty because it is unknown, and claiming "No Known Drug
        // Allergies" then is a statement about a patient whose allergies were never
        // seen. A failed read says so instead (the banner below).
        var showNkdaCard = (0, vue_3.computed)(function () { return stores.noAllergiesOnRecord; });
        function toggleMenu(id) {
            openMenuId.value = openMenuId.value === id ? null : id;
        }
        function handleView(id) {
            var allergy = stores.getAllergyById(id);
            if (allergy) {
                viewingAllergy.value = allergy;
            }
            openMenuId.value = null;
        }
        function handleDuplicate(id) {
            var allergy = stores.getAllergyById(id);
            if (allergy) {
                var _ = allergy.id, recordedDate = allergy.recordedDate, lastUpdated = allergy.lastUpdated, rest = __rest(allergy, ["id", "recordedDate", "lastUpdated"]);
                stores.addAllergy(__assign(__assign({}, rest), { name: "".concat(rest.name, " (Copy)"), recordedBy: 'Current User', lastUpdatedBy: 'Current User' }));
            }
            openMenuId.value = null;
        }
        function formatStatus(status) {
            return status.charAt(0).toUpperCase() + status.slice(1).replace(/-/g, ' ');
        }
        function formatSeverity(severity) {
            if (severity === 'life-threatening')
                return 'Life-Threatening';
            return severity.charAt(0).toUpperCase() + severity.slice(1);
        }
        function formatCriticality(criticality) {
            if (criticality === 'unable-to-assess')
                return 'Unable to Assess';
            return criticality.charAt(0).toUpperCase() + criticality.slice(1);
        }
        function formatVerification(status) {
            return status.charAt(0).toUpperCase() + status.slice(1).replace(/-/g, ' ');
        }
        function formatDate(dateStr) {
            var date = new Date(dateStr);
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        }
        // Close menu when clicking outside
        function handleClickOutside(e) {
            var target = e.target;
            if (!target.closest('.dropdown-container')) {
                openMenuId.value = null;
            }
        }
        (0, vue_3.onMounted)(function () {
            document.addEventListener('click', handleClickOutside);
        });
        (0, vue_3.onUnmounted)(function () {
            document.removeEventListener('click', handleClickOutside);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("h3", null, "Patient Allergies", -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("span", _hoisted_5, [
                                (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(activeCount.value), 1),
                                _cache[10] || (_cache[10] = (0, vue_2.createTextVNode)(" Active ", -1))
                            ]),
                            (highCriticalityCount.value > 0)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, [
                                    _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-exclamation-sign" }, null, -1)),
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(highCriticalityCount.value) + " High Risk ", 1)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]),
                    (showNkdaCard.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, __spreadArray([], (_cache[13] || (_cache[13] = [
                            (0, vue_2.createStaticVNode)("<div class=\"card-header\" data-v-611b3c1c><div class=\"allergy-name-row\" data-v-611b3c1c><span class=\"severity-indicator nkda\" data-v-611b3c1c></span><h4 class=\"allergy-name\" data-v-611b3c1c>No Known Drug Allergies</h4><span class=\"allergy-type-badge nkda\" data-v-611b3c1c>NKDA</span></div></div>", 1)
                        ])), true)))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn-add-allergy",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('add')); })
                        }, __spreadArray([], (_cache[14] || (_cache[14] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-plus" }, null, -1),
                            (0, vue_2.createTextVNode)(" Add Allergy ", -1)
                        ])), true))
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                    (0, vue_2.createElementVNode)("div", _hoisted_11, [
                        _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-search" }, null, -1)),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (((0, vue_2.unref)(stores).searchQuery) = $event); }),
                            type: "text",
                            placeholder: "Search allergies...",
                            class: "search-input"
                        }, null, 512), [
                            [vue_2.vModelText, (0, vue_2.unref)(stores).searchQuery]
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return (((0, vue_2.unref)(stores).statusFilter) = $event); }),
                            class: "filter-select"
                        }, __spreadArray([], (_cache[16] || (_cache[16] = [
                            (0, vue_2.createElementVNode)("option", { value: "all" }, "All Status", -1),
                            (0, vue_2.createElementVNode)("option", { value: "active" }, "Active", -1),
                            (0, vue_2.createElementVNode)("option", { value: "inactive" }, "Inactive", -1),
                            (0, vue_2.createElementVNode)("option", { value: "resolved" }, "Resolved", -1)
                        ])), true), 512), [
                            [vue_2.vModelSelect, (0, vue_2.unref)(stores).statusFilter]
                        ]),
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (((0, vue_2.unref)(stores).severityFilter) = $event); }),
                            class: "filter-select"
                        }, __spreadArray([], (_cache[17] || (_cache[17] = [
                            (0, vue_2.createStaticVNode)("<option value=\"all\" data-v-611b3c1c>All Severity</option><option value=\"life-threatening\" data-v-611b3c1c>Life-Threatening</option><option value=\"severe\" data-v-611b3c1c>Severe</option><option value=\"moderate\" data-v-611b3c1c>Moderate</option><option value=\"mild\" data-v-611b3c1c>Mild</option><option value=\"unknown\" data-v-611b3c1c>Unknown</option>", 6)
                        ])), true), 512), [
                            [vue_2.vModelSelect, (0, vue_2.unref)(stores).severityFilter]
                        ])
                    ])
                ]),
                ((0, vue_2.unref)(stores).loadError)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                        _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("strong", null, "Allergies could not be loaded.", -1)),
                        _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("span", null, "This list is unknown, not empty: do not assume the patient has no allergies.", -1)),
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "btn-retry-allergies",
                            onClick: _cache[4] || (_cache[4] = function ($event) { return ((0, vue_2.unref)(stores).getbackendAllergies()); })
                        }, "Try again")
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(vue_2.TransitionGroup, {
                    name: "allergy-card",
                    tag: "div",
                    class: "allergy-cards"
                }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (showNkdaCard.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, __spreadArray([], (_cache[20] || (_cache[20] = [
                                (0, vue_2.createElementVNode)("div", { class: "card-header" }, [
                                    (0, vue_2.createElementVNode)("div", { class: "allergy-name-row" }, [
                                        (0, vue_2.createElementVNode)("span", { class: "severity-indicator nkda" }),
                                        (0, vue_2.createElementVNode)("h4", { class: "allergy-name" }, "No Known Drug Allergies"),
                                        (0, vue_2.createElementVNode)("span", { class: "allergy-type-badge nkda" }, "NKDA")
                                    ])
                                ], -1)
                            ])), true)))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(stores).filteredAllergies, function (allergy) {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: allergy.id,
                                class: (0, vue_2.normalizeClass)(["allergy-card", {
                                        'high-criticality': allergy.criticality === 'high' && allergy.status === 'active',
                                        'resolved': allergy.status === 'resolved'
                                    }])
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                        (0, vue_2.createElementVNode)("span", {
                                            class: (0, vue_2.normalizeClass)(["severity-indicator", allergy.severity])
                                        }, null, 2),
                                        (0, vue_2.createElementVNode)("h4", _hoisted_17, (0, vue_2.toDisplayString)(allergy.name), 1),
                                        (0, vue_2.createElementVNode)("span", {
                                            class: (0, vue_2.normalizeClass)(["allergy-type-badge", allergy.type])
                                        }, (0, vue_2.toDisplayString)(allergy.type), 3)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "action-btn",
                                            onClick: function ($event) { return (_ctx.$emit('edit', allergy.id)); },
                                            title: "Edit"
                                        }, __spreadArray([], (_cache[21] || (_cache[21] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi bi-pencil" }, null, -1)
                                        ])), true), 8, _hoisted_19),
                                        (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "action-btn more-btn",
                                                onClick: function ($event) { return (toggleMenu(allergy.id)); },
                                                title: "More options"
                                            }, __spreadArray([], (_cache[22] || (_cache[22] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical" }, null, -1)
                                            ])), true), 8, _hoisted_21),
                                            (0, vue_2.createVNode)(vue_2.Transition, { name: "dropdown" }, {
                                                default: (0, vue_2.withCtx)(function () { return [
                                                    (openMenuId.value === allergy.id)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                onClick: function ($event) { return (handleView(allergy.id)); }
                                                            }, __spreadArray([], (_cache[23] || (_cache[23] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "bi bi-eye glyphicon-eye-open" }, null, -1),
                                                                (0, vue_2.createTextVNode)(" View Details ", -1)
                                                            ])), true), 8, _hoisted_23),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                onClick: function ($event) { return (_ctx.$emit('edit', allergy.id)); }
                                                            }, __spreadArray([], (_cache[24] || (_cache[24] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi bi-pencil" }, null, -1),
                                                                (0, vue_2.createTextVNode)(" Edit Allergy ", -1)
                                                            ])), true), 8, _hoisted_24),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                onClick: function ($event) { return (handleDuplicate(allergy.id)); }
                                                            }, __spreadArray([], (_cache[25] || (_cache[25] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-duplicate" }, null, -1),
                                                                (0, vue_2.createTextVNode)(" Duplicate ", -1)
                                                            ])), true), 8, _hoisted_25)
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ]; }, undefined, true),
                                                _: 2
                                            }, 1024)
                                        ])
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_28, [
                                            _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("span", { class: "info-label" }, "Status", -1)),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["status-pill", allergy.status])
                                            }, (0, vue_2.toDisplayString)(formatStatus(allergy.status)), 3)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                            _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("span", { class: "info-label" }, "Severity", -1)),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["severity-pill", allergy.severity])
                                            }, (0, vue_2.toDisplayString)(formatSeverity(allergy.severity)), 3)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                            _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("span", { class: "info-label" }, "Criticality", -1)),
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["criticality-pill", allergy.criticality])
                                            }, [
                                                (allergy.criticality === 'high')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_31))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(formatCriticality(allergy.criticality)), 1)
                                            ], 2)
                                        ])
                                    ]),
                                    (allergy.reactions.length > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_32, [
                                            _cache[29] || (_cache[29] = (0, vue_2.createElementVNode)("span", { class: "info-label" }, "Reactions", -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(allergy.reactions.slice(0, 4), function (reaction, idx) {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                        key: idx,
                                                        class: (0, vue_2.normalizeClass)(["reaction-chip", reaction.severity])
                                                    }, (0, vue_2.toDisplayString)(reaction.manifestation), 3));
                                                }), 128)),
                                                (allergy.reactions.length > 4)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_34, " +" + (0, vue_2.toDisplayString)(allergy.reactions.length - 4) + " more ", 1))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (allergy.crossReactivity.length > 0 && allergy.status === 'active')
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_35, [
                                            _cache[30] || (_cache[30] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-exclamation-sign" }, null, -1)),
                                            _cache[31] || (_cache[31] = (0, vue_2.createElementVNode)("span", { class: "alert-label" }, "Cross-Reactivity Alert:", -1)),
                                            (0, vue_2.createElementVNode)("span", _hoisted_36, (0, vue_2.toDisplayString)(allergy.crossReactivity.join(', ')), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                            _cache[32] || (_cache[32] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-calendar bi bi-calendar" }, null, -1)),
                                            (0, vue_2.createTextVNode)(" Recorded " + (0, vue_2.toDisplayString)(formatDate(allergy.recordedDate)), 1)
                                        ]),
                                        (allergy.resolvedDate)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_39, [
                                                _cache[33] || (_cache[33] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle bi bi-check" }, null, -1)),
                                                (0, vue_2.createTextVNode)(" Resolved " + (0, vue_2.toDisplayString)(formatDate(allergy.resolvedDate)), 1)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                            _cache[34] || (_cache[34] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-user bi bi-person" }, null, -1)),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(allergy.recordedBy), 1)
                                        ])
                                    ])
                                ])
                            ], 2));
                        }), 128))
                    ]; }, undefined, true),
                    _: 1
                }),
                ((0, vue_2.unref)(stores).loaded && !showNkdaCard.value && (0, vue_2.unref)(stores).filteredAllergies.length === 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_41, [
                        _cache[36] || (_cache[36] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-leaf" }, null, -1)),
                        _cache[37] || (_cache[37] = (0, vue_2.createElementVNode)("h4", null, "No Allergies Found", -1)),
                        _cache[38] || (_cache[38] = (0, vue_2.createElementVNode)("p", null, "Try adjusting your filters or search query.", -1)),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn-add-allergy",
                            onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.$emit('add')); })
                        }, __spreadArray([], (_cache[35] || (_cache[35] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-plus" }, null, -1),
                            (0, vue_2.createTextVNode)(" Add Allergy ", -1)
                        ])), true))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (viewingAllergy.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "modal-overlay",
                                onClick: _cache[9] || (_cache[9] = (0, vue_2.withModifiers)(function ($event) { return (viewingAllergy.value = null); }, ["self"]))
                            }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                            (0, vue_2.createElementVNode)("span", {
                                                class: (0, vue_2.normalizeClass)(["severity-indicator large", viewingAllergy.value.severity])
                                            }, null, 2),
                                            (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(viewingAllergy.value.name), 1)
                                        ]),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "close-btn",
                                            onClick: _cache[6] || (_cache[6] = function ($event) { return (viewingAllergy.value = null); })
                                        }, __spreadArray([], (_cache[39] || (_cache[39] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove" }, null, -1)
                                        ])), true))
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_45, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_46, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                                _cache[40] || (_cache[40] = (0, vue_2.createElementVNode)("label", null, "Type", -1)),
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: (0, vue_2.normalizeClass)(["allergy-type-badge", viewingAllergy.value.type])
                                                }, (0, vue_2.toDisplayString)(viewingAllergy.value.type), 3)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                                _cache[41] || (_cache[41] = (0, vue_2.createElementVNode)("label", null, "Status", -1)),
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: (0, vue_2.normalizeClass)(["status-pill", viewingAllergy.value.status])
                                                }, (0, vue_2.toDisplayString)(formatStatus(viewingAllergy.value.status)), 3)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                                _cache[42] || (_cache[42] = (0, vue_2.createElementVNode)("label", null, "Severity", -1)),
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: (0, vue_2.normalizeClass)(["severity-pill", viewingAllergy.value.severity])
                                                }, (0, vue_2.toDisplayString)(formatSeverity(viewingAllergy.value.severity)), 3)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_50, [
                                                _cache[43] || (_cache[43] = (0, vue_2.createElementVNode)("label", null, "Criticality", -1)),
                                                (0, vue_2.createElementVNode)("span", {
                                                    class: (0, vue_2.normalizeClass)(["criticality-pill", viewingAllergy.value.criticality])
                                                }, (0, vue_2.toDisplayString)(formatCriticality(viewingAllergy.value.criticality)), 3)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                                _cache[44] || (_cache[44] = (0, vue_2.createElementVNode)("label", null, "Verification", -1)),
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(formatVerification(viewingAllergy.value.verificationStatus)), 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                                _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("label", null, "Onset Date", -1)),
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(viewingAllergy.value.onsetDate ? formatDate(viewingAllergy.value.onsetDate) : 'Unknown'), 1)
                                            ])
                                        ]),
                                        (viewingAllergy.value.reactions.length > 0)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_53, [
                                                _cache[46] || (_cache[46] = (0, vue_2.createElementVNode)("label", null, "Reactions / Manifestations", -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(viewingAllergy.value.reactions, function (reaction, idx) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                            key: idx,
                                                            class: "reaction-detail"
                                                        }, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_55, (0, vue_2.toDisplayString)(reaction.manifestation), 1),
                                                            (0, vue_2.createElementVNode)("span", {
                                                                class: (0, vue_2.normalizeClass)(["reaction-severity", reaction.severity])
                                                            }, (0, vue_2.toDisplayString)(formatSeverity(reaction.severity)), 3)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (viewingAllergy.value.crossReactivity.length > 0)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_56, [
                                                _cache[48] || (_cache[48] = (0, vue_2.createElementVNode)("label", null, "Cross-Reactivity Warnings", -1)),
                                                (0, vue_2.createElementVNode)("div", _hoisted_57, [
                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(viewingAllergy.value.crossReactivity, function (item) {
                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                            key: item,
                                                            class: "cross-item"
                                                        }, [
                                                            _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-warning-sign" }, null, -1)),
                                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(item), 1)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (viewingAllergy.value.comments)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_58, [
                                                _cache[49] || (_cache[49] = (0, vue_2.createElementVNode)("label", null, "Clinical Notes", -1)),
                                                (0, vue_2.createElementVNode)("div", {
                                                    class: "comments-content",
                                                    innerHTML: viewingAllergy.value.comments
                                                }, null, 8, _hoisted_59)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_61, [
                                                _cache[50] || (_cache[50] = (0, vue_2.createElementVNode)("label", null, "Recorded By", -1)),
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(viewingAllergy.value.recordedBy) + " on " + (0, vue_2.toDisplayString)(formatDate(viewingAllergy.value.recordedDate)), 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_62, [
                                                _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("label", null, "Last Updated", -1)),
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(viewingAllergy.value.lastUpdatedBy) + " on " + (0, vue_2.toDisplayString)(formatDate(viewingAllergy.value.lastUpdated)), 1)
                                            ])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_63, [
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "btn-secondary",
                                            onClick: _cache[7] || (_cache[7] = function ($event) { return (viewingAllergy.value = null); })
                                        }, "Close"),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "btn-primary",
                                            onClick: _cache[8] || (_cache[8] = function ($event) { _ctx.$emit('edit', viewingAllergy.value.id); viewingAllergy.value = null; })
                                        }, __spreadArray([], (_cache[52] || (_cache[52] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil" }, null, -1),
                                            (0, vue_2.createTextVNode)(" Edit ", -1)
                                        ])), true))
                                    ])
                                ])
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
